const {Vue, jQuery: $} = window;

import {
	leadFormData
} from "../_utilities";
import { ACTIONS } from "../_actions";
import {store, store$} from "../_config-store";
import { localize } from "../_localize.js";

const viewOption$ = store$
	.map(state => state.viewOption);

const viewOptions$ = store$
	.map(state => state.viewOptions);

const childrenActive$ = store$
	.map(state => state.childrenActive);

const summaryActive$ = store$
	.map(state => state.summaryActive);

const activeDetails$ = store$
	.map(state => state.activeDetails);

const loading$ = store$
	.map(state => state.loading);

export const options = {
	template:
	`
	<div id="configurator" class="loading">
		<div id="configurator-main" v-bind:class="summaryActive ? 'summary-active' : ''">
			<div id="configurator-inner">
				<transition name="slide">
					<options-tray v-if="!summaryActive"></options-tray>
				</transition>
				<div id="configurator-viewers">
					<div class="vdom viewers" v-bind:data-viewer="view">
						<div id="exterior-builder"></div>
						<div id="interior-builder"></div>
						<misc-overlay></misc-overlay>
					</div>
					<dialog-overlay v-bind:view="view" v-if="windowWidth >= 768 || summaryActive"></dialog-overlay>
				</div>
				<transition name="fade">
					<modal-dialog v-if="childrenActive"></modal-dialog>
				</transition>
				<transition name="fade">
					<modal-details v-if="activeDetails"></modal-details>
				</transition>
				<div id="loader-overlay" v-if="loading !== false && false">
					<progress v-if="loading === true"></progress>
					<progress v-else max="100" v-bind:value="loading"></progress>
				</div>
			</div>
			<transition name="slide">
				<quote-summary v-if="summaryActive"></quote-summary>
			</transition>
		</div>
		<transition name="slide" @after-leave="triggerResize" @after-enter="triggerResize">
			<request-quote v-if="summaryActive && !leadForm"></request-quote>
			<lead-submit v-if="summaryActive && leadForm"></lead-submit>
		</transition>
		<dialog-overlay v-bind:view="view" v-if="windowWidth < 768 && !summaryActive"></dialog-overlay>
		<mobile-flip><label v-html="local('For best results, align your device vertically.')"></label></mobile-flip>
	</div>
	`,
	data() {
		return {
			windowWidth: this.getWindowWidth(),
			leadForm: leadFormData(),
			local(str){
				return str;
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			window.addEventListener('resize', () => {
				this.windowWidth = this.getWindowWidth();
			} );
		});
	},
	subscriptions() {
		return {
			loading: loading$,
			viewOption: viewOption$,
			viewOptions: viewOptions$,
			childrenActive: childrenActive$,
			summaryActive: summaryActive$,
			activeDetails: activeDetails$
		}
	},
	computed: {
		view(){
			let option = this.viewOptions[_.findIndex(this.viewOptions,{name: this.viewOption})];
			return option ? option.id : false;
		},
	},
	methods: {
		triggerResize() {
			store.dispatch({
				type: ACTIONS.RESIZE_EXTERIOR
			});
		},
		getWindowWidth(event) {
			return document.documentElement.clientWidth;
		},
	},
	created(){
		localize().then( local => this.local = local );
	}
}


Vue.component('configurator-main',options);